// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"6bbf07a5","416":"73c517bd","538":"1cd007b7","545":"363a01e3","566":"268bf185","614":"084c75c7","676":"2a417353","882":"5c81d053"}[chunkId] + ".chunk.js";
};